import '../styles/_fileDropZone.scss';

/** Why files from the last pick were left out (wrong type, too large, too many); nothing when none were. */
export const RejectedFiles = ({ reasons }: { reasons: string[] }) => {
    if (reasons.length === 0) {
        return null;
    }

    return (
        <div className='fileDropZone-rejections'>
            {reasons.map((reason) => (
                <div key={reason}>{reason}</div>
            ))}
        </div>
    );
};
